import styled from 'styled-components'
import { tokens, Input } from '@arvoreeducacao/bonsai-ds'

interface TitleProps {
  disabled?: boolean
  error?: boolean
}

export const SelectTitle = styled.p<TitleProps>`
  font-size: ${tokens.sizes.label}px;
  color: ${tokens.colors.black4};
  margin: 0;
  padding: ${({ disabled }) => (disabled ? '0' : '0 5px')};
  font-size: ${({ disabled }) =>
    disabled ? `${tokens.sizes.text}px` : `${tokens.sizes.label}px`};
  position: absolute;
  z-index: 1;
  transform: ${({ disabled }) =>
    disabled ? 'translate3d(15px, 40%, 0);' : 'translate3d(10px, -50%, 0);'};
  ${({ disabled }) => !disabled && `background: ${tokens.colors.white};`}
  ${({ error }) => error && `color: ${tokens.colors.red3};`}
`

export const SelectWrapper = styled.div`
  width: 100%;
  margin-top: 20px;

  @media (min-width: ${tokens.sizes.smScreen}px) {
    width: 100%;
  }
`

export const SelectResultsWrapper = styled.div`
  margin-top: 10px;
  width: 100%;
  margin-bottom: 20px;
  overflow: auto;
  position: relative;
  z-index: 10;

  > *:first-child {
    border-radius: ${tokens.radius.large} ${tokens.radius.large} 0 0;
  }

  > *:last-child {
    border-radius: 0 0 ${tokens.radius.large} ${tokens.radius.large};
  }

  > *:only-child {
    border-radius: ${tokens.radius.large};
  }
`

export const CustomInput = styled(Input).withConfig({
  shouldForwardProp: (prop: string) => prop !== 'active'
})`
  margin-bottom: 0;

  > label {
    display: none;
  }
`

export const CustomSelectResult = styled.div`
  border: 1px solid ${tokens.colors.black2};
  z-index: +1;
  background: ${tokens.colors.white};
  border-radius: inherit;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 16px;
`
